import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface GetProductByUserDTO {
  id: string;
  page: number;
  limit: number;
  sort?: string;
  search?: string;
  status?: number;
}

export type GetProductByUser = BaseResAPI<any>;

const getProductByUserInteractor = (
  params: GetProductByUserDTO
): Promise<GetProductByUser> => {
  const path = `/admin/user/${params.id}/products`;

  const { page, limit, sort, search, status } = params;
  let pathParam = "?";
  if (page) pathParam += `&page=${page}`;
  if (limit) pathParam += `&limit=${limit}`;
  if (sort) pathParam += `&sort=${sort}`;
  if (search) pathParam += `&search=${search}`;
  if (status) pathParam += `&status=${status}`;

  return api.get(pathParam === "?" ? path : path + pathParam);
};

export default getProductByUserInteractor;
